"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckmarkIcon = void 0;
const react_1 = __importDefault(require("react"));
const Theme_1 = require("../../Theme/Theme");
const CheckmarkIcon = (_a) => {
    var props = __rest(_a, []);
    return (react_1.default.createElement("svg", Object.assign({ width: "14", height: "14", viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("circle", { cx: "7", cy: "7", r: "7", fill: "#00A138" }),
        react_1.default.createElement("path", { d: "M10.5 5L5.99999 9.5L4 7.50001", stroke: Theme_1.theme.palette.BW_100, strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })));
};
exports.CheckmarkIcon = CheckmarkIcon;
